import { Link } from 'react-router-dom';

const articles = [
  {
    id: '01',
    title: 'GTBuy Sheet Guide',
    subtitle: '2026 Updated',
    type: 'guide',
    link: '/what-is-gtbuy-spreadsheet',
    isInternal: true,
  },
  {
    id: '02',
    title: 'vs Kakobuy & Superbuy',
    subtitle: 'Comparison',
    type: 'comparison',
    link: 'https://kaspreadsheet.com',
    isInternal: false,
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20comparison%20concept%20with%20two%20spreadsheet%20interfaces%20side%20by%20side%20on%20clean%20desk%20setup%2C%20soft%20natural%20lighting%20from%20window%2C%20warm%20cream%20and%20beige%20color%20palette%2C%20modern%20workspace%20aesthetic%2C%20editorial%20photography%20style%2C%20clean%20minimal%20composition%20with%20laptop%20and%20coffee%2C%20professional%20yet%20inviting%20atmosphere&width=800&height=600&seq=article-compare-002&orientation=landscape',
  },
  {
    id: '03',
    title: 'Automation Tips',
    subtitle: 'Workflow Optimization',
    type: 'tips',
    link: 'https://kaspreadsheet.com',
    isInternal: false,
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20workspace%20with%20organized%20desk%20showing%20spreadsheet%20automation%20workflow%20diagram%2C%20clean%20cream%20background%20with%20soft%20natural%20lighting%2C%20warm%20earthy%20color%20tones%2C%20modern%20editorial%20photography%2C%20professional%20yet%20minimal%20aesthetic%2C%20notebook%20and%20pen%20beside%20laptop%2C%20calm%20productive%20atmosphere&width=800&height=600&seq=article-tips-003&orientation=landscape',
  },
];

export default function SeoArticlesSection() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <div className="flex flex-col gap-2">
            <p className="font-heading text-sm text-secondary-500 font-medium uppercase tracking-widest">
              GTBuy Spreadsheet
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
              Guides & Comparisons
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {articles.map((article) => {
            if (article.isInternal) {
              return (
                <Link
                  key={article.id}
                  to={article.link}
                  className="group block rounded-3xl bg-primary-500 p-6 md:p-8 min-h-[280px] flex flex-col justify-between hover:bg-primary-600 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-12 h-12 rounded-2xl bg-background-50/10 flex items-center justify-center mb-6">
                    <span className="text-background-50/70 text-sm font-bold">{article.id}</span>
                  </div>
                  <div>
                    <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-tight mb-2">
                      {article.title}
                    </h3>
                    <p className="text-background-50/50 text-sm">{article.subtitle}</p>
                    <span className="inline-flex items-center gap-1.5 mt-4 text-accent-500 text-sm font-medium group-hover:gap-2.5 transition-all">
                      Read Article
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </Link>
              );
            }

            return (
              <a
                key={article.id}
                href={article.link}
                target="_blank"
                rel="noopener nofollow"
                className="group block rounded-3xl overflow-hidden relative min-h-[280px] cursor-pointer"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center"
                  style={{ backgroundImage: `url('${article.image}')` }}
                ></div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium">
                    {article.type.charAt(0).toUpperCase() + article.type.slice(1)}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 leading-tight">
                    {article.title}
                  </h3>
                  <p className="text-background-50/60 text-sm mt-1">{article.subtitle}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}